export default function ire(...args) {
  if (typeof window.ire !== 'function') {
    return;
  }

  return window.ire(...args);
}
